import { formatMMtoHHMM } from '@mummssoftware/utils/formatters';
import {
  workerValueGetter,
  travelTimeValueGetter,
  credentialsValueGetter,
} from './valueGetters';
import defaults from '../../translations/en.json';

const cellTooltipValueGetter = (params: any) => {
  const value =
    params.valueFormatted != null ? params.valueFormatted : params.value;
  if (value == null || value === '') {
    return '';
  }
  return String(value);
};

export const commonColumnDefs = {
  wrapText: true,
  sortable: true,
  filterable: true,
  autoHeight: true,
  flex: 1,
  resizable: true,
  tooltipValueGetter: cellTooltipValueGetter,
  cellStyle: {
    display: 'inline-block',
    position: 'absolute',
    overflow: 'ellipsis',
  },
};

export const detailRowDefs = {
  detailCellRendererParams: {
    detailGridOptions: {
      suppressLoadingOverlay: true,
    },
  },
};

const ProviderLarge = {
  headerName: defaults.visitProvider,
  valueGetter: workerValueGetter,
  width: 150,
  flex: 1.2,
};

const Role = {
  headerName: defaults.role,
  valueGetter: credentialsValueGetter,
  width: 75,
  maxWidth: 100,
  cellStyle: { textAlign: 'left' },
};

const OfficeLarge = {
  headerName: defaults.office,
  hide: true,
  width: 75,
  minWidth: 75,
  field: 'siteoffice',
};

const centeredStatCol = {
  headerClass: 'header-center',
  suppressMenu: true,
  cellStyle: { textAlign: 'center' },
};

const VisitCount = {
  headerName: defaults.unduplicated,
  minWidth: 75,
  maxWidth: 90,
  valueGetter: ({ data: { unduplicatedcnt } }: any) => `${unduplicatedcnt}`,
  ...centeredStatCol,
};

const VisitDuration = {
  headerName: defaults.visitDuration,
  wrapHeaderText: true,
  minWidth: 90,
  valueGetter: ({ data: { unduplicateddurationmins } }: any) =>
    formatMMtoHHMM(unduplicateddurationmins),
  ...centeredStatCol,
};

const TravelTime = {
  headerName: defaults.travelTime,
  wrapHeaderText: true,
  valueGetter: travelTimeValueGetter,
  minWidth: 90,
  ...centeredStatCol,
};

const Milage = {
  headerName: defaults.milage,
  minWidth: 75,
  valueGetter: ({ data: { unduplicatedmileage } }: any) =>
    `${unduplicatedmileage} mi`,
  ...centeredStatCol,
};

const Tolls = {
  headerName: defaults.tolls,
  minWidth: 75,
  valueGetter: (props: any) => `$${props.data.unduplicatedtolls}`,
  ...centeredStatCol,
};

const ProviderSmall = {
  headerName: defaults.visitProvider,
  valueGetter: workerValueGetter,
  width: 150,
  minWidth: 130,
};

const RoleSmall = {
  headerName: defaults.role,
  valueGetter: credentialsValueGetter,
  width: 150,
  minWidth: 50,
  cellStyle: { textAlign: 'left' },
};

export const smallWidgetVisitsColumnDefs = [ProviderSmall, RoleSmall];

export const expandedWidgetVisitsColumnDefs = [
  ProviderLarge,
  Role,
  OfficeLarge,
  VisitCount,
  VisitDuration,
  TravelTime,
  Milage,
  Tolls,
];
